import PolicyLayout from '../components/PolicyLayout';

export default function Terms() {
  return (
    <PolicyLayout title="Terms of Service">
      <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '-10px', marginBottom: '30px' }}>
        <em>Last updated: November 5, 2025</em>
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using VirtueSign, you agree to these Terms of Service. 
        If you do not agree, do not use the app.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        VirtueSign is an email signature management application that:
      </p>
      <ul>
        <li>Integrates with Microsoft Outlook (desktop, web, and mobile)</li>
        <li>Automatically generates email signatures from Microsoft 365 user profiles</li>
        <li>Provides administrators with centralized signature template management</li>
        <li>Automatically inserts signatures when composing emails</li>
      </ul>

      <h2>3. User Accounts</h2>
      <ul>
        <li>VirtueSign uses Microsoft 365 authentication - no separate account is required</li>
        <li>You are responsible for maintaining the security of your Microsoft 365 account</li>
        <li>You must have a valid Microsoft 365 business or enterprise subscription</li>
      </ul>

      <h2>4. Acceptable Use</h2>
      <p>You agree NOT to:</p>
      <ul>
        <li>Use VirtueSign for any illegal or unauthorized purpose</li>
        <li>Attempt to gain unauthorized access to the service or related systems</li>
        <li>Interfere with or disrupt the service</li>
        <li>Use the service to send spam or malicious content</li>
        <li>Reverse engineer, decompile, or disassemble any part of VirtueSign</li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p>
        VirtueSign and its original content, features, and functionality are owned by Virtue ApS 
        and are protected by international copyright, trademark, and other intellectual property laws.
      </p>

      <h2>6. Data and Privacy</h2>
      <p>
        Your use of VirtueSign is also governed by our <a href="/privacy">Privacy Policy</a>. 
        By using the app, you consent to the collection and use of data as described in the Privacy Policy.
      </p>

      <h2>7. Service Availability</h2>
      <ul>
        <li>We strive to provide reliable service but do not guarantee uninterrupted availability</li>
        <li>We may perform maintenance that temporarily interrupts service</li>
        <li>We reserve the right to modify or discontinue the service with reasonable notice</li>
      </ul>

      <h2>8. Limitation of Liability</h2>
      <p>
        VirtueSign is provided "as is" without warranties of any kind. 
        Virtue ApS shall not be liable for any indirect, incidental, special, or consequential damages 
        arising from your use of the app.
      </p>

      <h2>9. Subscription and Payment</h2>
      <ul>
        <li>VirtueSign may be offered on a subscription basis</li>
        <li>Pricing and billing terms will be provided separately</li>
        <li>Subscriptions may be managed through your organization's administrator</li>
      </ul>

      <h2>10. Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access to VirtueSign if you violate these terms. 
        Your organization may also terminate service at any time.
      </p>

      <h2>11. Changes to Terms</h2>
      <p>
        We may modify these terms at any time. 
        Continued use of VirtueSign after changes constitutes acceptance of the modified terms.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These terms are governed by the laws of Denmark. 
        Any disputes shall be resolved in Danish courts.
      </p>

      <h2>13. Contact Information</h2>
      <p>
        For questions about these terms, contact:
      </p>
      <p>
        <strong>Virtue ApS</strong><br />
        Email: <a href="mailto:support@virtue.dk">support@virtue.dk</a><br />
        Website: <a href="https://virtue.dk">https://virtue.dk</a>
      </p>
    </PolicyLayout>
  );
}
